// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file dashboard.proto (package grpc.api.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file dashboard.proto.
 */
export const file_dashboard: GenFile = /*@__PURE__*/
  fileDesc("Cg9kYXNoYm9hcmQucHJvdG8SC2dycGMuYXBpLnYxImkKFURhc2hib2FyZEF2YWlsYWJpbGl0eRIMCgRkYXRlGAEgASgFEg8KB3dlZWtkYXkYAiABKAUSEwoLaXNBdmFpbGFibGUYAyABKAgSDAoEZGF0YRgEIAEoCRIOCgZpc09wZW4YBSABKAhCBloELjtwYmIGcHJvdG8z");

/**
 * DashboardAvailability
 *
 * @generated from message grpc.api.v1.DashboardAvailability
 */
export type DashboardAvailability = Message<"grpc.api.v1.DashboardAvailability"> & {
  /**
   * @generated from field: int32 date = 1;
   */
  date: number;

  /**
   * @generated from field: int32 weekday = 2;
   */
  weekday: number;

  /**
   * @generated from field: bool isAvailable = 3;
   */
  isAvailable: boolean;

  /**
   * @generated from field: string data = 4;
   */
  data: string;

  /**
   * @generated from field: bool isOpen = 5;
   */
  isOpen: boolean;
};

/**
 * Describes the message grpc.api.v1.DashboardAvailability.
 * Use `create(DashboardAvailabilitySchema)` to create a new message.
 */
export const DashboardAvailabilitySchema: GenMessage<DashboardAvailability> = /*@__PURE__*/
  messageDesc(file_dashboard, 0);

